import { createFileRoute } from "@tanstack/react-router";
import { AdminPartnerApplications } from "@/components/admin/AdminPartnerApplications";

export const Route = createFileRoute("/_authenticated/admin/applications")({
  head: () => ({ meta: [{ title: "Partner Applications — Admin" }, { name: "robots", content: "noindex,nofollow" }] }),
  component: AdminPartnerApplications,
  errorComponent: ({ error }) => (
    <div className="p-8 text-sm text-rose-600">Failed to load: {(error as Error).message}</div>
  ),
  notFoundComponent: () => <div className="p-8">Not found</div>,
});
